import { render, staticRenderFns } from "./CustomerImportBanner.vue?vue&type=template&id=de90012e&scoped=true&"
import script from "./CustomerImportBanner.vue?vue&type=script&lang=ts&"
export * from "./CustomerImportBanner.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerImportBanner.vue?vue&type=style&index=0&id=de90012e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de90012e",
  null
  
)

export default component.exports